import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";

@observer
export class OriginalSizeButton extends Button {

	render() {
		return <Button {...this.props} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<circle cx="16" cy="12" r="2" />
					<circle cx="16" cy="20" r="2" />
					<path d="M30,2v28H2V2H30 M32,0H0v32h32V0L32,0z" />
					<rect x="6" y="6" width="4" height="20" />
					<rect x="22" y="6" width="4" height="20" />
				</svg>
			</i>
		</Button>;
	}
}